var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"productAttr-container"},[_c('div',{staticClass:"title"},[_vm._v("属性")]),_c('div',{staticClass:"list"},_vm._l((_vm.attributeList),function(v,i){return _c('block',{key:i},[_c('div',{staticClass:"item",class:_vm.changeIndex == i ? 'active' : 'default'},[_vm._v(" "+_vm._s("女装"))])])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }